import { Box, Button } from "@bca/ui-library";
import { useState, useEffect } from "react";
import { useRouter } from "next/router";
import styled from "styled-components";
import { BorderProps, border } from "styled-system";

import analytics from "../common/analytics/analytics";
import { IEventPushable } from "../common/analytics/analytics.types";
import ClearAllFiltersButton from "./ClearAllFiltersButton";
import { formatCount } from "./formatCount";
import { TRACKED } from "../constants";

const StyledFooter = styled(Box)<BorderProps>`
  bottom: 0;
  left: 0;
  position: fixed;
  margin-top: 15px;
  box-shadow: 0 0 25px 0 rgba(218, 218, 218, 0.5);
  ${border}
`;

const pushToAnalytics = () => {
  analytics.push<IEventPushable>({
    event: {
      name: "click",
      category: "button",
      label: "apply-filtered-results",
      action: "search",
    },
  });
};

const ApplyFiltersFooter = ({
  filtersCount,
  onClearAllFilters,
  resultCount,
  onClose,
  totalTracked,
}) => {
  const router = useRouter();
  const [viewportWidth, setViewportWidth] = useState(Number(window.innerWidth));

  const { requestOrigin } = router.query;
  const isTrackedPage = requestOrigin === TRACKED;

  useEffect(() => {
    window.addEventListener("resize", () =>
      setViewportWidth(window.innerWidth)
    );

    return () =>
      window.removeEventListener("resize", () =>
        setViewportWidth(window.innerWidth)
      );
  }, []);

  const totalResults = Boolean(resultCount) ? formatCount(resultCount) : "";
  const totalTrackedResults = Boolean(totalTracked)
    ? formatCount(totalTracked)
    : "";

  const buttonText = `See ${
    isTrackedPage ? totalTrackedResults : totalResults
  } Vehicles`;

  return (
    <StyledFooter
      px="20px"
      py="10px"
      backgroundColor="primary-white"
      width={viewportWidth < 470 ? "100%" : "309px"}
      height={viewportWidth < 470 ? "120px" : "116px"}
      display="flex"
      flexDirection="column"
      css={`
        z-index: 2;
      `}
      border="normalBorder"
    >
      <Box display="flex" alignItems="flex-end" flexDirection="column">
        <ClearAllFiltersButton
          filtersCount={filtersCount}
          onClearAllFilters={onClearAllFilters}
          underline={false}
        />
      </Box>
      <Button
        m="0 auto"
        mt="5px"
        height="42px"
        width={viewportWidth < 470 ? "95%" : "264px"}
        onClick={() => {
          onClose();
          pushToAnalytics();
        }}
        disabled={!Boolean(resultCount) || !Boolean(totalTracked)}
      >
        {buttonText}
      </Button>
    </StyledFooter>
  );
};

export default ApplyFiltersFooter;
